import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GungFile } from '../../models/pim';
import { ImageCarouselComponent } from '../image-carousel/image-carousel.component';

@Component({
  selector: 'lib-product-details-image-carousel',
  templateUrl: './product-details-image-carousel.component.html',
  styleUrl: './product-details-image-carousel.component.scss',
  standalone: false
})
export class ProductDetailsImageCarouselComponent extends ImageCarouselComponent implements OnInit {
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef<HTMLDivElement>;
  @Input() scrollingImagesCount = 3;
  @Input() documents: GungFile[] = [];
  thumbnailWidth = 68;
  scrollingContainerWidth = this.thumbnailWidth * 3 + 4;

  get currentIndex(): number {
    const id = this.myCarousel.activeId;
    const total = this.images.length + this.videos.length;
    for (let i = 0; i < total; i++) {
      if (this.imageIdString + i === id) {
        return i;
      }
    }
    return 0;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.scrollingContainerWidth = this.scrollingImagesCount * this.thumbnailWidth + 4;

    for (const img of this.images) {
      const imgUri = img?.extra?.s3UriEncoded || img?.s3Uri || '';
      let uri = imgUri;
      uri = decodeURIComponent(imgUri);
      img.extra._isGif = /\.gif(?:$|\?)/i.test(uri) ?? false;
    }

    // Append PIM video documents as slides at the end of the carousel
    const videoDocs = (this.documents || []).filter(d => d?.extra?.documentType === 'Video');
    for (const doc of videoDocs) {
      if (!doc.s3Uri) {
        continue;
      }
      this.videos.push({
        url: doc.s3Uri,
        provider: 'pim-video',
        code: doc.name || '',
        embed: doc.s3Uri
      });
    }
  }

  scrollToIndex(index: number) {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = index * this.thumbnailWidth;

    container.scrollTo({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }

  select(index: number): void {
    const total = this.images.length + this.videos.length;
    if (total === 0) {
      return;
    }
    const validIndex = ((index % total) + total) % total;

    super.select(validIndex);
    this.lastCarouselSelectedIndex = validIndex;
    this.scrollToIndex(Math.max(validIndex - 1, 0));
  }

  selectNext(): void {
    const index = this.currentIndex;
    this.select(index + 1);
  }

  selectPrevious(): void {
    const index = this.currentIndex;
    this.select(index - 1);
  }
}
